import { Button, Icon, Panel, PanelBody, PanelRow, TextareaControl, TextControl, Notice } from '@wordpress/components'
import { useSelect, dispatch } from '@wordpress/data'

import { __ } from '@wordpress/i18n'
import WPEditor from '../../fields/WPEditor'

const TabRows = props => {
    const {
        tabs,
        onContentChange,
        onTabAdd,
        onTabRemove
    } = props

    const defaultTab = { label: __('Tab label', 'wp-travel-pro'), content: __('Tab content goes here', 'wp-travel-pro') }
    return <>
        <div className="wp-travel-custom-tabs">
            {tabs.length < 1 && <Notice isDismissible={false} actions={[{
                    'label': __( 'Add New Tab', 'wp-travel-pro' ),
                    onClick:()=>{
                        onTabAdd(defaultTab)
                    },
                    noDefaultClasses:true,
                    className:'is-link'
                }]}>{__( 'No custom itineraries tab found.', 'wp-travel-pro')}</Notice>}
            {tabs.length > 0 && <PanelRow className="wp-travel-action-section"><span></span><Button variant="secondary" onClick={() => onTabAdd(defaultTab)}>{__('Add new tab')}</Button></PanelRow>}
            {tabs.length > 0 && tabs.map((tab, index) => {
                const { label, default_label, content } = tab
                return <PanelBody key={index} title={label ? label : __('Tab label', 'wp-travel-pro')} icon={() => <Icon icon="more" />} initialOpen={false}>
                    <PanelRow>
                        <label>{__('Tab label', 'wp-travel-pro')}</label>
                        <TextControl
                            value={label}
                            onChange={onContentChange('label', index)}
                        />
                    </PanelRow>
                    <PanelRow>
                        <label htmlFor={`tabs-tab-content-${index}`}>{__('Tab Content:', 'wp-travel-pro')}</label>
                    </PanelRow>
                    <PanelRow>
                        <WPEditor
                            id={`tabs-tab-content-${index}`}
                            onContentChange={onContentChange('content', index)}
                            value={content}
                        />
                    </PanelRow>
                    <PanelRow className="wp-travel-action-section has-right-padding">
                        <span></span>
                        <Button
                            isDestructive
                            variant="secondary"
                            className="wp-traval-button-danger"
                            onClick={() => {
                                if (!confirm('Are you sure to delete custom tab?')) {
                                    return false;
                                }
                                onTabRemove(index)
                            }
                            }>{__(`- Remove ${label}`, 'wp-travel-pro')}</Button>
                    </PanelRow>
                </PanelBody>

            })}
            {tabs.length > 1 && <PanelRow className="wp-travel-action-section"><span></span><Button variant="secondary" onClick={() => onTabAdd(defaultTab)}>{__('Add new tab')}</Button></PanelRow>}
        </div>
    </>
}

export default data => {
    const store = useSelect(select => select('WPTravel/TripEdit'))

    const tripData = store.getAllStore()
    const tabs = 'undefined' != typeof tripData.utilities && 'undefined' != typeof tripData.utilities.wp_travel_itinerary_custom_tab_cnt_ && tripData.utilities.wp_travel_itinerary_custom_tab_cnt_ || []
    const { updateTripData } = dispatch('WPTravel/TripEdit')

    // Settings
    useSelect((select) => {
        return  null !==  select('WPTravel/Admin') ? select('WPTravel/Admin').getSettings() : []
    }, []); // to load settings.
    
    const settings = useSelect((select) => {
        return  null !==  select('WPTravel/Admin') ? select('WPTravel/Admin').getAllStore() : []
    }, []);
    
    const { show_wp_travel_utilities } = settings;

    const handleChange = (name, index) => value => {
        let prevTabs = [...tabs]
        prevTabs.splice(index, 1, { ...tabs[index], [name]: value })
        updateTripData({
            ...tripData,
            utilities: {
                ...tripData.utilities,
                wp_travel_itinerary_custom_tab_cnt_: [...prevTabs],
            }
        })
    }

    const handleTabAdd = (tab) => {
        updateTripData({
            ...tripData,
            utilities: {
                ...tripData.utilities,
                wp_travel_itinerary_custom_tab_cnt_: [...tabs, { ...tab }],
            }
        })
    }

    const handleTabRemove = (index) => {
        let prevTabs = [...tabs]
        prevTabs.splice(index, 1)
        updateTripData({
            ...tripData,
            utilities: {
                ...tripData.utilities,
                wp_travel_itinerary_custom_tab_cnt_: [...prevTabs],
            }
        })
    }

    return 'undefined' != typeof show_wp_travel_utilities && 'yes' === show_wp_travel_utilities ?  <TabRows
        onContentChange={handleChange}
        tabs={tabs}
        onTabAdd={handleTabAdd}
        onTabRemove={handleTabRemove}
    /> :
    <> <>{__('WP Travel Utilities is currently disabled please go to Addons Settings to enable it to add custom tabs and reload the page.')}</></>
}